module.exports = /******/
function(modules) {
    /******/
    /******/
    // The require function
    /******/
    function __webpack_require__(moduleId) {
        /******/
        /******/
        // Check if module is in cache
        /******/
        if (installedModules[moduleId]) /******/
        return installedModules[moduleId].exports;
        /******/
        /******/
        // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
            /******/
            exports: {},
            /******/
            id: moduleId,
            /******/
            loaded: !1
        };
        /******/
        /******/
        // Return the exports of the module
        /******/
        /******/
        /******/
        // Execute the module function
        /******/
        /******/
        /******/
        // Flag the module as loaded
        /******/
        return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
        module.loaded = !0, module.exports;
    }
    // webpackBootstrap
    /******/
    // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/
    // Load entry module and return exports
    /******/
    /******/
    /******/
    /******/
    // expose the modules object (__webpack_modules__)
    /******/
    /******/
    /******/
    // expose the module cache
    /******/
    /******/
    /******/
    // __webpack_public_path__
    /******/
    return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
    __webpack_require__.p = "", __webpack_require__(0);
}([ /* 0 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = __webpack_require__(1);
}, /* 1 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.createError = exports.KeyPressHandler = exports.keyCode = exports.enumeration = void 0;
    var _keycode = __webpack_require__(2), _keycode2 = _interopRequireDefault(_keycode), _properties = __webpack_require__(3), _properties2 = _interopRequireDefault(_properties), _index = __webpack_require__(6), _index2 = _interopRequireDefault(_index), _createError = __webpack_require__(9), _createError2 = _interopRequireDefault(_createError);
    exports.enumeration = _properties2.default, exports.keyCode = _keycode2.default, 
    exports.KeyPressHandler = _index2.default, exports.createError = _createError2.default;
}, /* 2 */
/***/
function(module, exports) {
    module.exports = require("keycode");
}, /* 3 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    /* Helper function for creating new extensions to existing properties */
    function prop(def) {
        return function() {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
            return args.unshift({}, def), _assign2.default.apply(Object, args);
        };
    }
    /**
	  This property extension can be used with skate.
	  Usage:
	  ```
	  props: {
	      respondsTo: props.enum({values: ['toggle', 'hover'],
	      missingDefault: 'toggle',
	      invalidDefault: 'toggle'})({
	
	      })
	  }
	  ```
	 */
    function enumeration(enumOptions) {
        return prop({
            coerce: function(value) {
                return (0, _attributes.computeEnumValue)(enumOptions, value);
            },
            default: enumOptions.missingDefault,
            /* if the prop is an attribute, also add 'initial' with the default value so it get's set too*/
            initial: enumOptions.attribute ? enumOptions.missingDefault : void 0,
            deserialize: function(value) {
                return null === value ? void 0 : value;
            },
            serialize: function(value) {
                return "undefined" == typeof value ? value : String(value);
            }
        });
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _assign = __webpack_require__(4), _assign2 = _interopRequireDefault(_assign), _attributes = __webpack_require__(5);
    exports.default = enumeration;
}, /* 4 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/core-js/object/assign");
}, /* 5 */
/***/
function(module, exports) {
    "use strict";
    /**
	 * Like el.hasAttribute(attr) but designed for use within a skate attribute
	 * change handler where you only have access to change.oldValue.
	 */
    function computeBooleanValue(attrValue) {
        return null !== attrValue;
    }
    function setBooleanAttribute(el, attr, newValue) {
        newValue ? el.setAttribute(attr, "") : el.removeAttribute(attr);
    }
    function computeEnumValue(enumOptions, value) {
        var matchesEnumValue = function(enumValue) {
            return enumValue.toLowerCase() === value.toLowerCase();
        }, isMissing = null === value || "undefined" == typeof value, isInvalid = !isMissing && !enumOptions.values.filter(matchesEnumValue).length;
        return isMissing ? {}.hasOwnProperty.call(enumOptions, "missingDefault") ? enumOptions.missingDefault : null : isInvalid ? {}.hasOwnProperty.call(enumOptions, "invalidDefault") ? enumOptions.invalidDefault : {}.hasOwnProperty.call(enumOptions, "missingDefault") ? enumOptions.missingDefault : null : enumOptions.values.length ? enumOptions.values.filter(matchesEnumValue)[0] : null;
    }
    function setEnumAttribute(el, enumOptions, newValue) {
        el.setAttribute(enumOptions.attribute, newValue);
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), /**
	 * Helper functions useful for implementing reflected boolean and enumerated
	 * attributes and properties.
	 *
	 * @see https://html.spec.whatwg.org/multipage/infrastructure.html#reflecting-content-attributes-in-idl-attributes
	 * @see https://html.spec.whatwg.org/multipage/infrastructure.html#boolean-attribute
	 * @see https://html.spec.whatwg.org/multipage/infrastructure.html#enumerated-attribute
	 */
    exports.computeBooleanValue = computeBooleanValue, exports.setBooleanAttribute = setBooleanAttribute, 
    exports.computeEnumValue = computeEnumValue, exports.setEnumAttribute = setEnumAttribute;
}, /* 6 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function keyInvalidError(key) {
        return new KeyInvalidError('Given key "' + key + '" is not valid');
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.CallbackInvalidError = exports.KeyInvalidError = void 0;
    var _classCallCheck2 = __webpack_require__(7), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _keycode = __webpack_require__(2), _keycode2 = _interopRequireDefault(_keycode), _createError = __webpack_require__(8), _createError2 = _interopRequireDefault(_createError), KeyInvalidError = (0, 
    _createError2.default)("KeyInvalidError"), CallbackInvalidError = (0, _createError2.default)("CallbackInvalidError"), KeyPressHandler = function() {
        /**
	  * Adds a new keypress handler
	  *
	  * @constructor
	  * @param {String} key A named key. Case insensitive.
	  * @param {Function} callback A callback function to invoke if the given key was activated.
	  *                            The callback is passed the event object.
	  * @param {Node} [elem]  The element to listen for the key activation.
	  *                       Defaults to document if none given.
	  */
        function KeyPressHandler(key, callback, elem) {
            var _this = this;
            (0, _classCallCheck3.default)(this, KeyPressHandler), this.keyListeners = {};
            var code = (0, _keycode2.default)(key);
            if ("undefined" == typeof code) throw keyInvalidError(key);
            if ("function" != typeof callback) throw new CallbackInvalidError();
            this.keyListeners[code] = callback, this.elem = elem || document, this.listener = function(e) {
                _this.keyListeners[e.keyCode] && _this.keyListeners[e.keyCode](e);
            }, this.elem.addEventListener("keydown", this.listener);
        }
        /**
	  * Adds or replaces a key that is listened for.
	  *
	  * @param {String} key A named key. Case insensitive. Replaces any previous listened key.
	  * @param {Function} callback The callback function to invoke.
	  */
        /**
	  * Removes a key from the list of listened keys.
	  * Or removes the whole listener if no key given.
	  *
	  * @param {String} [key] A named key. Case insensitive. If none given, event listener is removed.
	  */
        return KeyPressHandler.prototype.add = function(key, callback) {
            var code = (0, _keycode2.default)(key);
            if ("undefined" == typeof code) throw keyInvalidError(key);
            if ("function" != typeof callback) throw new CallbackInvalidError();
            this.keyListeners[code] = callback;
        }, KeyPressHandler.prototype.destroy = function(key) {
            key ? delete this.keyListeners[(0, _keycode2.default)(key)] : (// Don't change this to {}, otherwise a destroyed KeyPressHandler can be "recycled"
            // without having an event listener attached
            this.keyListeners = void 0, this.elem.removeEventListener("keydown", this.listener));
        }, KeyPressHandler;
    }();
    exports.default = KeyPressHandler, exports.KeyInvalidError = KeyInvalidError, exports.CallbackInvalidError = CallbackInvalidError;
}, /* 7 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/classCallCheck");
}, /* 8 */
/***/
function(module, exports) {
    module.exports = require("create-error");
}, /* 9 */
/***/
function(module, exports) {
    "use strict";
    function createError(propName, componentName, message) {
        return new Error("Invalid prop `" + propName + "` supplied to" + (" `" + componentName + "`. " + message));
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.default = createError;
} ]);


//////////////////
// WEBPACK FOOTER
// ../util-common/dist/bundle-cjs.js
// module id = 255
// module chunks = 0